import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider, useAuth } from './context/AuthContext';

//Component
import Layout from './components/Layout';

// Public pages
import HomePage from './pages/HomePage';
import VantaggiESGPage from './pages/VantaggiESGPage';
import AboutPage from './pages/ChiSiamoPage';
import FaqPage from './pages/FaqPage';
import ContattiPage from './pages/ContattiPage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import VerifyEmailPage from './pages/VerifyEmailPage';


// User pages
import DashboardLayout from './pages/user/DashboardLayout';
import ProjectsPage from './pages/user/ProjectsPage';
import NewProjectPage from './pages/user/NewProjectPage';
import QuestionnairePage from './pages/user/QuestionnairePage';
import ProjectDetailPage from './pages/user/ProjectDetailPage';
import CompanySetupPage from './pages/user/CompanySetupPage';

// Certifier/Admin pages
import AdminLayout from './pages/admin/AdminLayout';
import AdminDashboardPage from './pages/admin/AdminDashboardPage';
import AdminProjectsPage from './pages/admin/AdminProjectsPage';
import AdminProjectDetailPage from './pages/admin/AdminProjectDetailPage';
import AdminUsersPage from './pages/admin/AdminUsersPage';

function ProtectedRoute({ children, roles }) {
  const { user, loading } = useAuth();
  if (loading) return <div style={{ padding: 40, textAlign: 'center' }}>Caricamento...</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/dashboard" replace />;
  return children;
}

function PublicRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (user) return <Navigate to={user.role === 'user' ? '/dashboard' : '/admin'} replace />;
  return children;
}

function AppRoutes() {
  return (
    <Routes>
      {/* Layout */}
      <Route path="/" element={<Layout><HomePage /></Layout>} />
      <Route path="/vantaggi" element={<Layout><VantaggiESGPage /></Layout>} />

      {/* Public */}
      <Route path="/" element={<HomePage />} />
      <Route path="/vantaggi" element={<VantaggiESGPage />} />
      <Route path="/verify-email" element={<VerifyEmailPage />} />
      <Route path="/about" element={<Layout><AboutPage /></Layout>} />
      <Route path="/faq" element={<Layout><FaqPage /></Layout>} />
      <Route path="/contatti" element={<Layout><ContattiPage /></Layout>} />
      <Route path="/login" element={<PublicRoute><Layout><LoginPage /></Layout></PublicRoute>} />
      <Route path="/register" element={<PublicRoute><Layout><RegisterPage /></Layout></PublicRoute>} />

      {/* User — first-time company setup */}
      <Route path="/setup" element={<ProtectedRoute><CompanySetupPage /></ProtectedRoute>} />

      {/* User dashboard */}
      <Route path="/dashboard" element={<ProtectedRoute><DashboardLayout /></ProtectedRoute>}>
        <Route index element={<ProjectsPage />} />
        <Route path="new-project" element={<NewProjectPage />} />
        <Route path="projects/:id" element={<ProjectDetailPage />} />
        <Route path="projects/:id/questionnaire" element={<QuestionnairePage />} />
      </Route>

      {/* Admin / Certifier */}
      <Route path="/admin" element={<ProtectedRoute roles={['certifier', 'admin']}><AdminLayout /></ProtectedRoute>}>
        <Route index element={<AdminDashboardPage />} />
        <Route path="projects" element={<AdminProjectsPage />} />
        <Route path="projects/:id" element={<AdminProjectDetailPage />} />
        <Route path="users" element={<ProtectedRoute roles={['admin']}><AdminUsersPage /></ProtectedRoute>} />
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Toaster position="top-right" toastOptions={{ duration: 3500 }} />
        <AppRoutes />
      </AuthProvider>
    </BrowserRouter>
  );
}
